export interface AuditData {
  before?: any;
  after?: any;
  fields?: string[];
}

export interface LogEntry {
  id: string;
  timestamp: string;
  type: 'info' | 'success' | 'warning' | 'error';
  action: string;
  details: string;
  store: string;
  user?: string;
  entityType?: 'product' | 'order' | 'user' | 'system';
  entityId?: string | number;
  audit?: AuditData;
}

export const addAppLog = (
  type: 'info' | 'success' | 'warning' | 'error', 
  action: string, 
  details: string,
  extra: Partial<Omit<LogEntry, 'id' | 'timestamp' | 'type' | 'action' | 'details'>> = {}
) => {
  if (typeof window === 'undefined') return;
  const activeId = localStorage.getItem('wc_active_store_id') || 'default';
  const currentUser = localStorage.getItem('app_username') || 'Admin';
  
  const newLog: LogEntry = {
    id: Math.random().toString(36).substr(2, 9),
    timestamp: new Date().toISOString(),
    type,
    action,
    details,
    store: activeId,
    user: currentUser,
    ...extra
  };

  try {
    const logs = JSON.parse(localStorage.getItem('swift_woo_manager_logs') || '[]');
    const updatedLogs = [newLog, ...logs].slice(0, 500);
    localStorage.setItem('swift_woo_manager_logs', JSON.stringify(updatedLogs));
    window.dispatchEvent(new CustomEvent('swift-woo-log-update'));
  } catch (e) {
    console.warn("Audit Log failed, but main operation continues", e);
  }
};
